/*
 * banner-image-parallax.js
 * Sanfter Parallax-Effekt fuer banner-image-Sections.
 * Aktiv nur wenn data-parallax-strength="soft" oder "strong" auf der Section gesetzt ist.
 */
(function () {
  'use strict';

  if (window.__bannerImageParallaxInit) return;
  window.__bannerImageParallaxInit = true;

  var MOBILE_MAX = 767;
  var SOFT_RATIO = 0.10;
  var SOFT_SCALE = 1.10;
  var STRONG_RATIO = 0.30;
  var STRONG_SCALE = 1.20;

  var motionMql = window.matchMedia('(prefers-reduced-motion: reduce)');
  var mobileMql = window.matchMedia('(max-width: ' + MOBILE_MAX + 'px)');

  var active = new Set();
  var observed = new Set();
  var ticking = false;
  var enabled = false;
  var observer = null;

  function getImages(section) {
    return section.querySelectorAll('.banner-image__image-container img');
  }

  function getVisibleImage(section) {
    var imgs = getImages(section);
    for (var i = 0; i < imgs.length; i++) {
      if (imgs[i].offsetParent !== null) return imgs[i];
    }
    return null;
  }

  function isFixedMode(img) {
    return !!img.closest('.fix_parallax_effect');
  }

  function runsOnCurrentViewport(section) {
    return !mobileMql.matches || section.dataset.parallaxMobile === 'true';
  }

  function getParams(section) {
    if (section.dataset.parallaxStrength === 'strong') {
      return { scale: STRONG_SCALE, ratio: STRONG_RATIO };
    }
    return { scale: SOFT_SCALE, ratio: SOFT_RATIO };
  }

  function updateSection(section) {
    if (!runsOnCurrentViewport(section)) {
      clearSection(section);
      return;
    }
    var img = getVisibleImage(section);
    if (!img || isFixedMode(img)) return;

    var rect = section.getBoundingClientRect();
    var vh = window.innerHeight || document.documentElement.clientHeight;
    var total = vh + rect.height;
    if (total <= 0 || rect.height <= 0) return;

    var progress = (vh - rect.top) / total;
    if (progress < 0) progress = 0;
    if (progress > 1) progress = 1;

    var params = getParams(section);
    var overhang = (img.offsetHeight * (params.scale - 1)) / 2;
    var maxShift = Math.min(rect.height * params.ratio, overhang);
    var offset = (progress - 0.5) * 2 * maxShift;

    img.style.transform =
      'translate3d(0, ' + offset.toFixed(1) + 'px, 0) scale(' + params.scale + ')';
  }

  function clearSection(section) {
    var imgs = getImages(section);
    for (var i = 0; i < imgs.length; i++) {
      imgs[i].style.transform = '';
    }
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      active.forEach(updateSection);
      ticking = false;
    });
  }

  function ensureObserver() {
    if (observer) return observer;
    observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            active.add(entry.target);
            updateSection(entry.target);
          } else {
            active.delete(entry.target);
            clearSection(entry.target);
          }
        });
      },
      { rootMargin: '100px 0px 100px 0px' }
    );
    return observer;
  }

  function attach(section) {
    if (!section || observed.has(section)) return;
    var strength = section.dataset.parallaxStrength;
    if (strength !== 'soft' && strength !== 'strong') return;
    observed.add(section);
    ensureObserver().observe(section);
  }

  function detach(section) {
    if (!section || !observed.has(section)) return;
    observed.delete(section);
    active.delete(section);
    if (observer) observer.unobserve(section);
    clearSection(section);
  }

  function collect() {
    return document.querySelectorAll(
      '[data-section-type="banner-image"][data-parallax-strength="soft"], ' +
        '[data-section-type="banner-image"][data-parallax-strength="strong"]'
    );
  }

  function enable() {
    if (enabled) return;
    enabled = true;
    collect().forEach(attach);
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
  }

  function disable() {
    if (!enabled) return;
    enabled = false;
    window.removeEventListener('scroll', onScroll);
    window.removeEventListener('resize', onScroll);
    observed.forEach(function (section) {
      active.delete(section);
      if (observer) observer.unobserve(section);
      clearSection(section);
    });
    observed.clear();
  }

  function shouldRun() {
    return !motionMql.matches;
  }

  function refresh() {
    if (shouldRun()) enable();
    else disable();
  }

  function addMqlListener(mql, handler) {
    if (mql.addEventListener) mql.addEventListener('change', handler);
    else if (mql.addListener) mql.addListener(handler);
  }

  addMqlListener(motionMql, refresh);
  addMqlListener(mobileMql, onScroll);

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target && event.target.querySelector
      ? event.target.querySelector('[data-section-type="banner-image"]')
      : null;
    if (!section) return;
    if (shouldRun()) attach(section);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var section = event.target && event.target.querySelector
      ? event.target.querySelector('[data-section-type="banner-image"]')
      : null;
    if (section) detach(section);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh);
  } else {
    refresh();
  }
})();